module.exports = __webpack_public_path__ + "static/media/checkbox-circle-line.6b725714.svg";